function checkSetDates() {
    if(!$('#search-arrival').val() || !$('#search-departure').val()) {
        alert('Vyberte datum příjezdu a odjezdu');
        return false;
    }
}

$("body").on("submit","form#search.index:not(.ignore-dates)",function(){
    return checkSetDates();
});